// extracted by mini-css-extract-plugin
export default {"style_tag":"startTag_style_tag__tNbz-"};